import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vue-product-card__label" }
const _hoisted_2 = ["type", "name", "value", "checked"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "vue-product-card__footer" }
const _hoisted_5 = { class: "vue-product-card__title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "vue-product-card",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('selected')), ["prevent"])),
    onKeyup: [
      _cache[1] || (_cache[1] = _withKeys($event => (_ctx.$emit('selected')), ["enter"])),
      _cache[2] || (_cache[2] = _withKeys($event => (_ctx.$emit('selected')), ["space"]))
    ],
    tabindex: "0"
  }, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("input", {
        class: "vue-product-card__input",
        type: $props.allowMultiple ? 'checkbox' : 'radio',
        name: $props.inputName,
        value: $props.product.id,
        checked: $props.isActive
      }, null, 8 /* PROPS */, _hoisted_2),
      _createElementVNode("img", {
        class: "vue-product-card__image",
        src: $props.product.featured_image,
        alt: $props.product.title
      }, null, 8 /* PROPS */, _hoisted_3)
    ]),
    _createElementVNode("footer", _hoisted_4, [
      _createElementVNode("h4", _hoisted_5, _toDisplayString($props.product.title), 1 /* TEXT */),
      _createVNode($setup["FormattedPrice"], {
        price: $props.product.price,
        "class-name": "vue-product-card__price"
      }, null, 8 /* PROPS */, ["price"])
    ])
  ], 32 /* NEED_HYDRATION */))
}